export default "__VITE_ASSET__Bb5194P6__"